import { ReactNode } from 'react';
import { Box, Button, Typography, useTheme } from '@mui/material';

// Icons.
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import { getNeedHelpButtonStyles } from './NeedHelpSx';

type NeedHelpButtonProps = {
  children?: ReactNode;
  'data-testid'?: string;
  endIcon?: ReactNode;
  startIcon?: ReactNode;
  subtitle: string;
  title: string;
  onClick?: () => void;
};

const NeedHelpButton = ({
  children,
  'data-testid': dataTestId,
  endIcon,
  startIcon,
  subtitle,
  title,
  onClick = () => {},
}: NeedHelpButtonProps) => {
  const theme = useTheme();

  return (
    <Button
      data-testid={dataTestId}
      onClick={onClick}
      variant="outlined"
      startIcon={startIcon ?? <ForumOutlinedIcon fontSize="large" />}
      endIcon={endIcon ?? <ArrowForwardRoundedIcon fontSize="large" />}
      sx={getNeedHelpButtonStyles(theme)}
    >
      <Box sx={{ flex: 1 }}>
        <Typography
          className="help-button-title"
          variant="subtitle2"
          gutterBottom
        >
          {title}
        </Typography>
        <Typography
          className="help-button-subtitle"
          variant="body2"
        >
          {subtitle}
        </Typography>
      </Box>
      {children}
    </Button>
  );
};

export default NeedHelpButton;
